<div class="modal-header">
    <h4 class="modal-title pull-left">{{ title }}</h4>
    <button type="button" class="btn btn-icon btn-close btn-transparent" aria-label="Close" (click)="decline()">
        <sb-inline-svg
            class="icon icon-close"
            aria-label="My icon"
            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
        </sb-inline-svg>
    </button>
</div>
<div class="modal-body">
    <div class="form-group">
        <label for="comment" translate>Message:</label>
        <textarea class="form-control" id="comment" [(ngModel)]="comment" appFocus [appAutoFocus]="true"></textarea>
    </div>

    <div class="form-group">
        <label class="label-as-container">
            <span class="label-value" translate>Users:</span>
            @if (users.length > 0) {
                <app-tags-input
                    [selectedItems]="newUsers"
                    [items]="users"
                    [contentType]="'users'"
                    displayBy="label"
                    placeholder="{{ 'Select users' | translate }}">
                </app-tags-input>
            }
        </label>
        @if (isAddingNewUsersAllowed) {
            <a [hidden]="isShowForm" (click)="isShowForm = !isShowForm" translate>or add new user</a>
            @if (isShowForm) {
                <div>
                    <p translate class="mb-0 mt-4">Add a new user</p>
                    <app-new-vendor-form
                        (closeForm)="isShowForm = false"
                        (addNewUser)="addNewUser($event[0], $event[1], $event[2], $event[3])"
                        [isAddingUser]="isAddingUser">
                    </app-new-vendor-form>
                </div>
            }
        }
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="decline()" translate>Cancel</button>
    <button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="!this.newUsers.length">
        {{ confirmText }}
    </button>
</div>
